export enum SubscriptionStatusDisplay {
    ACTIVE = 'Active',
    PAUSED = 'Paused',
    CANCELED = 'Canceled',
    PENDING = 'Pending'
}